import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {Chart} from 'angular-highcharts';
import {PointOptionsObject} from 'highcharts';
import {IntelligenceData} from '../../../models/intelligence-data.interface';
import {INTELLIGENCE_PIE_COLORS} from '../../../../constants/charts';
import {MessageService} from '../../../../shared/services/message.service';
import {Router} from '@angular/router';
import {AuthService} from '../../../../core/services/auth.service';

@Component({
  selector: 'app-weee-system-retail-vs-municipalities-vs-other-pie-chart',
  templateUrl: './weee-system-retail-vs-municipalities-vs-other-pie-chart.component.html',
  styleUrls: ['./weee-system-retail-vs-municipalities-vs-other-pie-chart.component.scss']
})
export class WeeeSystemRetailVsMunicipalitiesVsOtherPieChartComponent implements OnInit, OnChanges {

  textBelow!: string;
  chart!: Chart;
  chartData!: any[];
  pieCategories!: string[];
  textBelowCode = 'intelligence.WeeeSystem.RetailVsMunicipalitiesVsOther.textBelow';
  isAdmin!: boolean;

  @Input()
  title!: string;
  @Input()
  subtitle!: string;
  @Input()
  data!: IntelligenceData[];

  private static getPieCategories(chartData: IntelligenceData[]): string[] {
    const pieCategories = chartData.map(item => item.questionDescription.includes('retail') ? 'Retail' : (item.questionDescription.includes('municipal') ? 'Municipalities' : 'Other'));
    return [...new Set(pieCategories)];
  }

  constructor(private readonly messageService: MessageService,
              private readonly router: Router,
              private authService: AuthService) {
  }

  ngOnInit(): void {
    this.isAdmin = this.authService.getUserRoles().includes('WF_ADMIN');
    this.messageService.getDialogInfo(this.textBelowCode).subscribe((data) => {
      if (data !== null) {
        this.textBelow = data.description;
      }
    });
  }

  ngOnChanges(): void {
    if (this.data) {
      this.pieCategories = WeeeSystemRetailVsMunicipalitiesVsOtherPieChartComponent.getPieCategories(this.data);
      this.chartData = this.convertToChartData();
      this.chart = new Chart({
        chart: {
          type: 'pie',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },
        colors: INTELLIGENCE_PIE_COLORS,
        title: {
          text: this.title
        },
        subtitle: {
          text: this.subtitle
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.percentage:.1f} %'
            }
          }
        },
        exporting: {
          enabled: true,
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        tooltip: {
          formatter(): string[] | undefined {
            if (this.point.name) {
              const pointOptions = this.point as PointOptionsObject;
              if (this.point.percentage) {
                return ['<div class="center"><b>' + this.point.name + ' - ' + this.point?.percentage.toFixed(2) + '%</b></div><br><br>',
                  '- Total responses: ' + pointOptions.custom?.totalResponses + '<br>'
                ];
              }
            }
            // If not null, use the default formatter
            // return tooltip.defaultFormatter.call(this, tooltip);
            return undefined;
          }
        },
        series: [{
          name: 'Value (%)',
          type: 'pie',
          data: this.chartData
        }]
      });
    }
  }

  editTextBelow(): void {
    this.router.navigate(['/admin/chart-labels'], {state: {code: this.textBelowCode}}).then(
      () => {
        // do nothing
      }
    );
  }

  private convertToChartData(): any[] {
    this.chart?.ref?.hideData();
    const chartData: any[] = [];
    let totalSum = 0;
    this.data.forEach(item => totalSum += item.totalSum);
    this.data.forEach((item, index) => {
      chartData.push({
        y: +((item.totalSum / totalSum) * 100).toFixed(2),
        name: this.pieCategories[index],
        custom: {
          totalResponses: item.totalResponses,
          average: item.totalResponses / item.totalRespondents * 100,
        }
      });
    });
    return chartData;
  }

}
